module.exports = __webpack_public_path__ + "img/10551382_S.baa5e983.png";